/*** IMPORTS FROM imports-loader ***/
var define = false;

import "../../utilities/globals/index.js";
export { empty } from "./empty.js";
export { from } from "./from.js";
export { split } from "./split.js";
export { concat } from "./concat.js";
export { execute } from "./execute.js";
export { ApolloLink } from "./ApolloLink.js";
export * from "./types.js";
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/core/index.js
// module id = 155
// module chunks = 0